export default theme => ({
	root: {
		position: 'absolute',
		width: '100%',
		height: '100vh',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		background: 'url(./static/img/background.jpg) no-repeat 50%',
		backgroundSize: 'cover',
		backgroundColor: '#2089a6',
		'@media (max-width: 768px)': {
			height: '105vh'
		},
		'@media (max-width: 576px)': {
			height: '140vh'
		}
	},
	logo: {
		width: 380,
		height: 100,
		marginTop: '6%',
		'@media (max-width: 425px)': {
			width: 300
		}
	},
	title: {
		marginTop: 60,
		fontSize: '32px',
		lineHieght: '1.5',
		fontWeight: '500',
		color: 'white',
		textAlign: 'center',
		whiteSpace: 'normal',
		padding: '0px 8px'
	},
	text: {
		marginTop: theme.spacing.unit * 2,
		color: 'white',
		maxWidth: 570,
		fontSize: '24px',
		lineHieght: '1.25',
		fontWeight: '300',
		textAlign: 'center',
		padding: '0px 16px'
	},
	button: {
		...theme.typography.button,
		marginTop: 50,
		width: 215
	}
});
